import { render, staticRenderFns } from "./RightLowerBarEditGroupConfirmation.vue?vue&type=template&id=6c63b345&scoped=true&"
import script from "./RightLowerBarEditGroupConfirmation.vue?vue&type=script&lang=js&"
export * from "./RightLowerBarEditGroupConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c63b345",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c63b345')) {
      api.createRecord('6c63b345', component.options)
    } else {
      api.reload('6c63b345', component.options)
    }
    module.hot.accept("./RightLowerBarEditGroupConfirmation.vue?vue&type=template&id=6c63b345&scoped=true&", function () {
      api.rerender('6c63b345', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/LowerBar/LowerBarRightSide/RightLowerBarEditGroupConfirmation.vue"
export default component.exports